import React, { useEffect, useContext, useState } from "react";
import "./LobbyScreen.css";
import "../src/styles/font.css";
import { ScreenContext } from "./App";
import backgroundImage from "./Assets/Images/AppDashboard/HomeScreen/HomeScreenBG.png";
import playerProfile from "./Assets/Images/AppDashboard/HomeScreen/PlayerProfile.png";

import { InitializeGameBoardExport } from "./GameBoard";

import Loading from "./Loading";
import { handleZIndexChangeLoadingExport } from "./Loading";

import {
  setSelectedGameModeExport,
} from "./PlayerSelectionScreen";

let handleZIndexChangeLobbyExport;
let InitializeLobbyDataExport;

const LobbyScreen = () => {
  const [zIndex, setZIndex] = useState(-1000); // Initial z-index value
  const [selectedPlayersCount, setselectedPlayersCount] = useState(null);

  const handleScreenChange = useContext(ScreenContext);
  const [selectedGameMode, setSelectedGameMode] = useState("");

  useEffect(() => {
    if (selectedPlayersCount !== null && selectedPlayersCount !== undefined) {
      console.log("Hiding Loading Screen");
      handleZIndexChangeLoadingExport();
    }
  }, [selectedPlayersCount]);

  const BACK = async () => {

    handleZIndexChangeLoadingExport();
    await handleScreenChange("PlayerSelection"); // Change to the 'Game' screen
    setSelectedGameModeExport(selectedGameMode);

  };

  const handleZIndexChange = (isAutoPlayDice) => {
    console.log("Handle Z Index is Called || Lobby Screen");
    // Change the z-index value
    setZIndex((prevZIndex) => (prevZIndex === 1000 ? -1000 : 1000));

    console.log(`Lobby Screen Loaded with ZIndex  ====> ${zIndex}`);
  };

  const InitializeLobbyData = (playersCount, gameMode) => {
    console.log(
      `Initialed Lobby Data || Players Count ====> ${playersCount} || GameMode ====> ${gameMode} `
    );
    setselectedPlayersCount(playersCount);
    setSelectedGameMode(gameMode);
  };

  const StartGame = async () => {
    console.log(
      `Loading Gameplay || Players ====> ${selectedPlayersCount} || Game Mode ====> ${selectedGameMode}`
    );
    await handleScreenChange("Game");
    InitializeGameBoardExport(selectedGameMode, selectedPlayersCount);
  };

  handleZIndexChangeLobbyExport = handleZIndexChange;
  InitializeLobbyDataExport = InitializeLobbyData;

  return (
    <div className="lobby-screen" style={{ zIndex }}>
      <div>{<Loading />}</div>

      {/* Your Logo and other elements */}
      <div className="lobby-wrapper" style={{ width: "75%" }}>
        <img
          src={require("./Assets/Images/AppDashboard/LobbyScreen/LobbyPanel.png")}
          alt="LobbyPanel"
          className="lobby-panel"
        />
        {/* Lobby Title */}
        <img
          src={require("./Assets/Images/AppDashboard/LobbyScreen/LobbyTitle.png")}
          alt="lobbyTitle"
          className="lobby-title"
        />
        <img
          src={require("./Assets/Images/AppDashboard/backBtn.png")}
          alt="BackButton"
          className="back-button"
          onClick={BACK}
        />
        <img
          src={require("./Assets/Images/AppDashboard/LobbyScreen/Seprator.png")}
          alt="Seprator"
          className="Seprator"
        />
        {/* Player 1 Data Holder */}
        {selectedPlayersCount && selectedPlayersCount >= 1 && (
          <div
            className="player-data-container"
            style={{
              position: "absolute",
              top: "56%",
              left: "15%",
              width: "16%",
              height: "auto",
              transform: "translate(-50%, -50%)",
              textAlign: "center",
            }}
          >
            <img
              src={require("./Assets/Images/AppDashboard/LobbyScreen/playerDataHolder.png")}
              alt="profileDataHolder"
              className="profile-data-holder"
              style={{
                width: "100%",
                height: "auto",
                position: "relative",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            />
            {/* Image 1 */}
            <img
              src={require("./Assets/Images/AppDashboard/LobbyScreen/playerProfile.png")}
              alt="Image 1"
              style={{
                width: "45%",
                height: "auto",
                position: "absolute",
                top: "-1%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            />
            {/* Text 1 */}
            <div
              style={{
                color: "white",
                fontSize: "2vw",
                fontFamily: "Gomarice",
                position: "absolute",
                top: "-40%",
                left: "50%",
                width: "90%",
                height: "auto",
                transform: "translate(-50%, -50%)",
              }}
            >
              GUEST
            </div>
            {/* Text 2 */}
            <div
              style={{
                color: "white", 
                fontSize: "2vw",
                fontFamily: "Gomarice",
                position: "absolute",
                bottom: "38%",
                left: "50%",
                width: "90%",
                height: "auto",
                transform: "translate(-50%, -50%)",
              }}
            >
              YOU
            </div>
          </div>
        )}

        {/* Player 2 Data Holder */}
        {selectedPlayersCount && selectedPlayersCount >= 2 && (
          <div
            className="player-data-container"
            style={{
              position: "absolute",
              top: "56%",
              left: "36.5%",
              width: "16%",
              height: "auto",
              transform: "translate(-50%, -50%)",
              textAlign: "center",
            }}
          >
            <img
              src={require("./Assets/Images/AppDashboard/LobbyScreen/playerDataHolder.png")}
              alt="profileDataHolder"
              className="profile-data-holder"
              style={{
                width: "100%",
                height: "auto",
                position: "relative",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            />
            {/* Image 1 */}
            <img
              src={require("./Assets/Images/AppDashboard/LobbyScreen/botPlayer.png")}
              alt="Image 1"
              style={{
                width: "45%",
                height: "auto",
                position: "absolute",
                top: "-1%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            />
            {/* Text 1 */}
            <div
              style={{
                color: "white",
                fontSize: "2vw",
                fontFamily: "Gomarice",
                position: "absolute",
                top: "-40%",
                left: "50%",
                width: "90%",
                height: "auto",
                transform: "translate(-50%, -50%)",
              }}
            >
              ROBOT 1
            </div>
            {/* Text 2 */}
            <div
              style={{
                color: "white",
                fontSize: "2vw",
                fontFamily: "Gomarice",
                position: "absolute",
                bottom: "38%",
                left: "50%",
                width: "90%",
                height: "auto",
                transform: "translate(-50%, -50%)",
              }}
            >
              READY
            </div>
          </div>
        )}

        {/* Player 3 Data Holder */}
        {selectedPlayersCount && selectedPlayersCount >= 3 && (
          <div
            className="player-data-container"
            style={{
              position: "absolute",
              top: "56%",
              left: "58%",
              width: "16%",
              height: "auto",
              transform: "translate(-50%, -50%)",
              textAlign: "center",
            }}
          >
            <img
              src={require("./Assets/Images/AppDashboard/LobbyScreen/playerDataHolder.png")}
              alt="profileDataHolder"
              className="profile-data-holder"
              style={{
                width: "100%",
                height: "auto",
                position: "relative",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            />
            {/* Image 1 */}
            <img
              src={require("./Assets/Images/AppDashboard/LobbyScreen/botPlayer.png")}
              alt="Image 1"
              style={{
                width: "45%",
                height: "auto",
                position: "absolute",
                top: "-1%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            />
            {/* Text 1 */}
            <div
              style={{
                color: "white",
                fontSize: "2vw",
                fontFamily: "Gomarice",
                position: "absolute",
                top: "-40%",
                left: "50%",
                width: "90%",
                height: "auto",
                transform: "translate(-50%, -50%)",
              }}
            >
              ROBOT 2
            </div>
            {/* Text 2 */}
            <div
              style={{
                color: "white",
                fontSize: "2vw",
                fontFamily: "Gomarice",
                position: "absolute",
                bottom: "38%",
                left: "50%",
                width: "90%",
                height: "auto",
                transform: "translate(-50%, -50%)",
              }}
            >
              READY
            </div>
          </div>
        )}

        {/* Player 4 Data Holder */}
        {selectedPlayersCount && selectedPlayersCount >= 4 && (
          <div
            className="player-data-container"
            style={{
              position: "absolute",
              top: "89%",
              left: "15%",
              width: "16%",
              height: "auto",
              transform: "translate(-50%, -50%)",
              textAlign: "center",
            }}
          >
            <img
              src={require("./Assets/Images/AppDashboard/LobbyScreen/playerDataHolder.png")}
              alt="profileDataHolder"
              className="profile-data-holder"
              style={{
                width: "100%",
                height: "auto",
                position: "relative",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            />
            {/* Image 1 */}
            <img
              src={require("./Assets/Images/AppDashboard/LobbyScreen/botPlayer.png")}
              alt="Image 1"
              style={{
                width: "45%",
                height: "auto",
                position: "absolute",
                top: "-1%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            />
            {/* Text 1 */}
            <div
              style={{
                color: "white",
                fontSize: "2vw",
                fontFamily: "Gomarice",
                position: "absolute",
                top: "-40%",
                left: "50%",
                width: "90%",
                height: "auto",
                transform: "translate(-50%, -50%)",
              }}
            >
              ROBOT 3
            </div>
            {/* Text 2 */}
            <div
              style={{
                color: "white",
                fontSize: "2vw",
                fontFamily: "Gomarice",
                position: "absolute",
                bottom: "38%",
                left: "50%",
                width: "90%",
                height: "auto",
                transform: "translate(-50%, -50%)",
              }}
            >
              READY
            </div>
          </div>
        )}

        {/* Player 5 Data Holder */}
        {selectedPlayersCount && selectedPlayersCount >= 5 && (
          <div
            className="player-data-container"
            style={{
              position: "absolute",
              top: "89%",
              left: "36.5%",
              width: "16%",
              height: "auto",
              transform: "translate(-50%, -50%)",
              textAlign: "center",
            }}
          >
            <img
              src={require("./Assets/Images/AppDashboard/LobbyScreen/playerDataHolder.png")}
              alt="profileDataHolder"
              className="profile-data-holder"
              style={{
                width: "100%",
                height: "auto",
                position: "relative",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            />
            {/* Image 1 */}
            <img
              src={require("./Assets/Images/AppDashboard/LobbyScreen/botPlayer.png")}
              alt="Image 1"
              style={{
                width: "45%",
                height: "auto",
                position: "absolute",
                top: "-1%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            />
            {/* Text 1 */}
            <div
              style={{
                color: "white",
                fontSize: "2vw",
                fontFamily: "Gomarice",
                position: "absolute",
                top: "-40%",
                left: "50%",
                width: "90%",
                height: "auto",
                transform: "translate(-50%, -50%)",
              }}
            >
              ROBOT 4
            </div>
            {/* Text 2 */}
            <div
              style={{
                color: "white",
                fontSize: "2vw",
                fontFamily: "Gomarice",
                position: "absolute",
                bottom: "38%",
                left: "50%",
                width: "90%",
                height: "auto",
                transform: "translate(-50%, -50%)",
              }}
            >
              READY
            </div>
          </div>
        )}

        {/* Player 6 Data Holder */}
        {selectedPlayersCount && selectedPlayersCount >= 6 && (
          <div
            className="player-data-container"
            style={{
              position: "absolute",
              top: "89%",
              left: "58%",
              width: "16%",
              height: "auto",
              transform: "translate(-50%, -50%)",
              textAlign: "center",
            }}
          >
            <img
              src={require("./Assets/Images/AppDashboard/LobbyScreen/playerDataHolder.png")}
              alt="profileDataHolder"
              className="profile-data-holder"
              style={{
                width: "100%",
                height: "auto",
                position: "relative",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            />
            {/* Image 1 */}
            <img
              src={require("./Assets/Images/AppDashboard/LobbyScreen/botPlayer.png")}
              alt="Image 1"
              style={{
                width: "45%",
                height: "auto",
                position: "absolute",
                top: "-1%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            />
            {/* Text 1 */}
            <div
              style={{
                color: "white",
                fontSize: "2vw",
                fontFamily: "Gomarice",
                position: "absolute",
                top: "-40%",
                left: "50%",
                width: "90%",
                height: "auto",
                transform: "translate(-50%, -50%)",
              }}
            >
              ROBOT 5
            </div>
            {/* Text 2 */}
            <div
              style={{
                color: "white",
                fontSize: "2vw",
                fontFamily: "Gomarice",
                position: "absolute",
                bottom: "38%",
                left: "50%",
                width: "90%",
                height: "auto",
                transform: "translate(-50%, -50%)",
              }}
            >
              READY
            </div>
          </div>
        )}

        {/* Select Booster Panel */}
        <div
          style={{
            width: "24%",
            position: "absolute",
            top: "58%",
            left: "71%",
          }}
        >
          <img
            src={require("./Assets/Images/AppDashboard/LobbyScreen/SelectBoosterPanel.png")}
            alt="Select Booster Panel"
            className="profile-data-holder"
            style={{
              width: "100%",
              height: "auto",
              position: "relative",
              top: "20%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          />
          <div>
            <img
              src={require("./Assets/Images/AppDashboard/LobbyScreen/BoosterBG.png")}
              alt="Booster Background"
              className="booster-bg-image"
              style={{ width: "100%", height: "auto",top:'-33%',position:'absolute' }}
            />

            <img
              src={require("./Assets/Images/AppDashboard/LobbyScreen/BoosterImage.png")}
              alt="Image 1"
              className="booster-image"
              style={{
                width: "20%",
                height: "10%",
                position: "absolute",
                top: "-19%",
                left: "22%",
                transform: "translate(-50%, -50%)",
              }}
            />

            <div
              style={{
                color: "white",
                fontSize: "1.2vw",
                fontFamily: "Gomarice",
                position: "absolute",
                width: "65%",
                height: "50%",
                top: "-2%",
                left: "68%",
                transform: "translate(-50%, -50%)",
              }}
            >
              Military Point personal use
            </div>
          </div>
          <div>
            <img
              src={require("./Assets/Images/AppDashboard/LobbyScreen/BoosterBG.png")}
              alt="Booster Background"
              className="booster-bg-image"
              style={{ width: "100%", height: "auto",top:'-6%',position:'absolute' }}
            />

            <img
              src={require("./Assets/Images/AppDashboard/LobbyScreen/BoosterImage.png")}
              alt="Image 1"
              className="booster-image"
              style={{
                width: "20%",
                height: "10%",
                position: "absolute",
                top: "8%",
                left: "22%",
                transform: "translate(-50%, -50%)",
              }}
            />

            <div
              style={{
                color: "white",
                fontSize: "1.2vw",
                fontFamily: "Gomarice",
                position: "absolute",
                width: "65%",
                height: "50%",
                top: "25%",
                left: "68%",
                transform: "translate(-50%, -50%)",
              }}
            >
              Military Point personal use
            </div>
          </div>
          <div>
            <img
              src={require("./Assets/Images/AppDashboard/LobbyScreen/BoosterBG.png")}
              alt="Booster Background"
              className="booster-bg-image"
              style={{ width: "100%", height: "auto",top:'20%',position:'absolute' }}
            />

            <img
              src={require("./Assets/Images/AppDashboard/LobbyScreen/BoosterImage.png")}
              alt="Image 1"
              className="booster-image"
              style={{
                width: "20%",
                height: "10%",
                position: "absolute",
                top: "34%",
                left: "22%",
                transform: "translate(-50%, -50%)",
              }}
            />

            <div
              style={{
                color: "white",
                fontSize: "1.2vw",
                fontFamily: "Gomarice",
                position: "absolute",
                width: "65%",
                height: "50%",
                top: "51%",
                left: "68%",
                transform: "translate(-50%, -50%)",
              }}
            >
              Military Point personal use
            </div>
          </div>
        </div>

        {/* <div className="player-data-container" style={{ position: 'absolute', top: '85%', right: '-10%', width: '25%', height: '90%', transform: 'translate(-50%, -50%)', textAlign: 'center' }}>
                    <img
                        src={require('./Assets/Images/AppDashboard/LobbyScreen/SelectBoosterPanel.png')}
                        alt="Select Booster Panel"
                        className="profile-data-holder"
                        style={{ width: '100%', height: 'auto', position: 'relative', top: '20%', left: '50%', transform: 'translate(-50%, -50%)' }}
                    />
                    
    
                    <div className="booster-bg" style={{ position: 'relative', width: '90%', height: 'auto', top: '-58%', left: '50%', transform: 'translate(-50%, -50%)' }}>

                         <img
                            src={require('./Assets/Images/AppDashboard/LobbyScreen/BoosterBG.png')}
                            alt="Booster Background"
                            className="booster-bg-image"
                            style={{ width: '100%', height: 'auto' }}
                        />
        
                        <img
                            src={require('./Assets/Images/AppDashboard/LobbyScreen/BoosterImage.png')}
                            alt="Image 1"
                            className="booster-image"
                            style={{ width: '20%', height: '40%', position: 'absolute', top: '55%', left: '22%', transform: 'translate(-50%, -50%)' }}
                        />
        
                        <div style={{ color: 'white', fontSize: '1.2vw', fontFamily: 'Gomarice', position: 'absolute', width: '65%', height: '50%', bottom: '0', left: '60%', transform: 'translate(-50%, -50%)' }}>Military Point personal use</div>

                    </div>

                    <div className="booster-bg" style={{ position: 'relative', width: '90%', height: 'auto', top: '-58%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                         <img
                            src={require('./Assets/Images/AppDashboard/LobbyScreen/BoosterBG.png')}
                            alt="Booster Background"
                            className="booster-bg-image"
                            style={{ width: '100%', height: 'auto' }}
                        />
        
                        <img
                            src={require('./Assets/Images/AppDashboard/LobbyScreen/BoosterImage.png')}
                            alt="Image 1"
                            className="booster-image"
                            style={{ width: '20%', height: '40%', position: 'absolute', top: '55%', left: '22%', transform: 'translate(-50%, -50%)' }}
                        />
        
                        <div style={{ color: 'white', fontSize: '1.2vw', fontFamily: 'Gomarice', position: 'absolute', width: '65%', height: '50%', bottom: '0', left: '60%', transform: 'translate(-50%, -50%)' }}>Military Point personal use</div>

                    </div>

                    <div className="booster-bg" style={{ position: 'relative', width: '90%', height: 'auto', top: '-58%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                         <img
                            src={require('./Assets/Images/AppDashboard/LobbyScreen/BoosterBG.png')}
                            alt="Booster Background"
                            className="booster-bg-image"
                            style={{ width: '100%', height: 'auto' }}
                        />
        
                        <img
                            src={require('./Assets/Images/AppDashboard/LobbyScreen/BoosterImage.png')}
                            alt="Image 1"
                            className="booster-image"
                            style={{ width: '20%', height: '40%', position: 'absolute', top: '55%', left: '22%', transform: 'translate(-50%, -50%)' }}
                        />
        
                        <div style={{ color: 'white', fontSize: '1.2vw', fontFamily: 'Gomarice', position: 'absolute', width: '65%', height: '50%', bottom: '0', left: '60%', transform: 'translate(-50%, -50%)' }}>Military Point personal use</div>

                    </div>
                    
                </div> */}

        {/* Ready Button */}
        <img
          src={require("./Assets/Images/AppDashboard/LobbyScreen/readyBtn.png")}
          alt="Image 1"
          style={{
            width: "20%",
            height: "auto",
            position: "absolute",
            bottom: "-10%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
          onClick={StartGame}
        />
      </div>
      {/* Full Screen Image */}
      {/* <div className="full-screen-image" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundImage: `url(${require('./Assets/Images/AppDashboard/LobbyScreen/LobbyRef.png')})`, opacity: 0.3, zIndex: 2 }}></div> 8 */}
    </div>
  );
};

export { handleZIndexChangeLobbyExport, InitializeLobbyDataExport };
export default LobbyScreen;